var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('main',[_vm._t("default")],2),_vm._v(" "),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }